import {OktaAuth} from '@okta/okta-auth-js'
import AWSAppSyncClient, {AUTH_TYPE} from 'aws-appsync';

export class AppsyncService {

    appSyncClient: AWSAppSyncClient<any>;

    constructor(private appsyncEndpoint: string, private oktaAuth: OktaAuth) {

        this.appSyncClient = new AWSAppSyncClient(
            {
                url: appsyncEndpoint!,
                region: 'eu-west-1',
                auth: {
                    type: AUTH_TYPE.OPENID_CONNECT,
                    jwtToken: async () => oktaAuth.getAccessToken()!,
                },
                disableOffline: true
            });
    }
}
